import { App } from "antd";
import type { NotificationArgsProps } from "antd";

type NotificationPlacement = NotificationArgsProps["placement"];

export const useNotification = () => {
  // From App.useApp(): the toasts render through the <App> in index.tsx, so
  // there is no contextHolder to mount.
  const { notification } = App.useApp();

  const notify = (
    type: "success" | "error" | "info" | "warning",
    message: string,
    description: string,
    placement: NotificationPlacement = "topLeft"
  ) => {
    notification[type]({
      message,
      description,
      placement,
    });
  };

  return { notify };
};
